(() => {
  if (customElements.get('complementary-products-carousel')) {
    return;
  }

  class ComplementaryProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.activeSlider = {};
      this.controls = null;
      this.controlsWrapper = this.querySelector('[data-controls-wrapper]');
      this.progressBar = this.querySelector('[data-progress-bar]');
    }

    connectedCallback() {
      this.initSlider();
    }

    /**
     * Initialize slider.
     * @param {String} query - Selector query for slider element
     * @returns 
     */
    initSlider(query = '[data-slider]') {
      const sliderList = this.querySelector(query);

      if (!sliderList) return;

      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
      
      // eslint-disable-next-line no-undef
      const slider = new Splide(sliderList, {
        trimSpace: false,
        waitForTransition: true,
        flickMaxPages: 0.5,
        fixedWidth: '350px',
        gap: '10px',
        perMove: 1,
        pagination: false,
        arrows: false,
        speed: 300,
        easing: 'ease-in-out',
        breakpoints: {
          400: {
            fixedWidth: 'calc(100vw - 40px)',
            gap: '5px'
          }
        },
        rewind: false,
      }).mount();

      this.activeSlider = slider;
      this.initProgressBar(slider);
      this.updateArrowStates(slider);

      slider.on('moved', () => {
        this.updateArrowStates(slider);
      });
    }

    /**
     * Initialize progress bar UI for mobile.
     * @param {Object} slider - Splide slider object
     */
    initProgressBar(slider) {  
      const bar = this.querySelector('[data-progress-bar]')

      if (!bar) {
        return;
      }

      bar.style.width = '0';

      slider.on( 'mounted move', function () {
        var end  = slider.Components.Controller.getEnd() + 1;
        var rate = Math.min( ( slider.index + 1 ) / end, 1 );
        bar.style.width = String( 100 * rate ) + '%';
      } );
    }

    /**
     * Update arrow disabled states based on current slide position.
     * @param {Object} slider - Splide slider object
     */
    updateArrowStates(slider) {
      if (!this.controls) return;

      const prevButton = this.querySelector('[data-control][data-prev]');
      const nextButton = this.querySelector('[data-control][data-next]');
      
      if (!prevButton || !nextButton) return;

      const currentIndex = slider.index;
      const totalSlides = slider.length;

      currentIndex === 0 ?
        prevButton.setAttribute('disabled', '') :
        prevButton.removeAttribute('disabled');

      currentIndex === totalSlides - 1 ?
        nextButton.setAttribute('disabled', '') :
        nextButton.removeAttribute('disabled');
    }

    onControlClick(event) {
      event.preventDefault();

      if (!this.activeSlider) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.activeSlider.go(action);
    }
  }

  customElements.define('complementary-products-carousel', ComplementaryProductsCarousel);
})();